import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseOfferBlock } from '../blocks.types'

export const FeaturedOffersBlockFragment: BlockFragment = {
  name: 'featuredOffers',
  fragment: gql`
    fragment featuredOffers on FeaturedOffers {
      id
      blockName
      blockType
      displayStyle

      showEndTime
      cardType
      featuredOfferLimit: limit
      offers {
        id
        name
        tag
        description
        thumbnailImage {
          id
          url
          alt
        }
        featuredImage {
          id
          url
          alt
        }
        brand {
          id
          slug
          logo {
            id
            url
            alt
          }
        }
        slug
        expiresAt
        isBookmarked
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on FeaturedOffers {
      id
      blockName
      blockType
      displayStyle

      showEndTime
      cardType
      featuredOfferLimit: limit
      offers {
        id
        name
        tag
        description
        thumbnailImage {
          id
          url
          alt
        }
        featuredImage {
          id
          url
          alt
        }
        brand {
          id
          slug
          logo {
            id
            url
            alt
          }
        }
        slug
        expiresAt
        isBookmarked
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
    `,
}

export const FeaturedOffersBlockType = 'featuredOffers'

export interface FeaturedOffersBlock extends BaseOfferBlock {
  blockType: typeof FeaturedOffersBlockType
  featuredOfferLimit: number
  displayStyle: DisplayStyle
  // complexView?: boolean
  showEndTime?: boolean
  // withBackgroundImage?: boolean
  cardType?: 'complexView' | 'withBackgroundImage'
  imagePriority?: boolean
  offers: {
    id: string
    name: string
    thumbnailImage: {
      url: string
      alt: string
    }
    featuredImage: {
      url: string
      alt: string
    }
    slug: string
    description?: string
    tag?: string
    brand: {
      slug: string
      logo: {
        url: string
        alt: string
      }
    }
    expiresAt?: string
    isBookmarked: boolean
  }[]
}

export type DisplayStyle = 'carousel' | 'grid'
